/* eslint import/prefer-default-export: 0 */
// Exports different exceptions to throw
export class PropertyException extends Error {
    constructor(propertiesNotFound = 'Property not found...', ...args) {
        super(...args);
        this.name = 'PropertyException';
        this.message = `Property or properties not found... ${propertiesNotFound}`;
    }
}
